// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","cls1":"_1zKDP","cls2":"_2v51I","cls3":"_1gJIr"};